import { create } from 'zustand';
import { MeasurementMap } from '../../../data-access/gql-types/graphql';
import { setCacheData } from '../storage/cache';
import { MeasurementMapPick } from '../types/cache';

type MeasurementMapStore = {
  measurementMap: MeasurementMapPick | null;
  setMeasurementMap: (measurementMap: MeasurementMap, saveInStorage?: boolean) => void;
};

export const useMeasurementMapStore = create<MeasurementMapStore>()((set) => ({
  measurementMap: null,
  setMeasurementMap: (measurementMap: MeasurementMap, saveInStorage?: boolean) => {
    if (saveInStorage) {
      setCacheData({ kind: 'common', commonData: { measurementMap } });
    }

    const { meter, optimizer } = measurementMap;
    set(() => ({ measurementMap: { meter, optimizer } }));
  },
}));
